import { Injectable } from "@angular/core";
import { ProfileService } from 'app/profile/services/profile.service';
import { GeneralSettingsState } from '../state/general.state';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { GET_GENERAL_SETTINGS, GetGeneralSettingsSuccess } from '../actions/general.action';
import { withLatestFrom, exhaustMap, filter, switchMap, catchError } from 'rxjs/operators';
import { getGeneralSettings } from '../selectors/general.selector';
import { IncrementLoaderCount, DecrementLoaderCount, PushError } from 'app/shared/store/actions';
import { Store } from '@ngrx/store';


@Injectable()
export class GeneralSettingsEffects {
    constructor(private service: ProfileService,
        private store: Store<GeneralSettingsState>,
        private actions$: Actions) {}

    @Effect()
    loadGeneralSettings$ = this.actions$
        .pipe(
            ofType(GET_GENERAL_SETTINGS),
            withLatestFrom(this.store.select(getGeneralSettings)),
            filter(([, state]) => state == null),
            exhaustMap(() => {
                this.store.dispatch(new IncrementLoaderCount());
                return this.service.getGeneralSettings()
                    .pipe(
                        switchMap(res => {
                            return [
                                new GetGeneralSettingsSuccess(res),
                                new DecrementLoaderCount()
                            ]
                        }),
                        catchError(err => {
                            return [
                                new PushError(err),
                                new DecrementLoaderCount()
                            ]
                        })
                    )
            })
        );
}